import ArgonBox from "components/ArgonBox";
import React, { useState, useEffect } from "react";
import Table from "examples/Tables/Table";
import ArgonTypography from "components/ArgonTypography";
import classManagmentTableData from "./data/classManagmentTableData";
import PropTypes from "prop-types";
import axios from "utils/api";
import Card from "@mui/material/Card";
import EventNoteIcon from "@mui/icons-material/EventNote";

function classManagment({ parentId, onStatusChange }) {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const allStatuses = "CREATED,SCHEDULED,ONGOING,ON_HOLD,COMPLETED,DISCONTINUED";

  useEffect(() => {
    const fetchClasses = async () => {
      if (!parentId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `/classes/sessions/all?parentId=${parentId}&status=${allStatuses}`
        );
        if (response.data.success) {
          const classesData = response.data.data || [];
          setClasses(classesData);
          if (onStatusChange) {
            onStatusChange(classesData.length === 0 ? "error" : "success");
          }
        } else {
          setClasses([]);
          if (onStatusChange) {
            onStatusChange("error");
          }
        }
      } catch (err) {
        console.error("Error fetching classes:", err);
        setError("Error fetching classes data");
        setClasses([]);
        if (onStatusChange) {
          onStatusChange("error");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, [parentId, onStatusChange]);

  const { columns, rows } = classManagmentTableData(classes);
  return (
    <ArgonBox>
      {loading ? (
        <ArgonBox>
          <Card sx={{ p: 5 }}>
            <ArgonBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
            >
              <ArgonTypography variant="h6" color="text">
                Loading Classes Data...
              </ArgonTypography>
            </ArgonBox>
          </Card>
        </ArgonBox>
      ) : error ? (
        <ArgonBox>
          <Card sx={{ p: 5 }}>
            <ArgonBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
            >
              <EventNoteIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
              <ArgonTypography variant="h6" color="error">
                {error}
              </ArgonTypography>
            </ArgonBox>
          </Card>
        </ArgonBox>
      ) : rows.length === 0 ? (
        <ArgonBox>
          <Card sx={{ p: 5 }}>
            <ArgonBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
            >
              <EventNoteIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
              <ArgonTypography variant="h6" color="text">
                No Classes Available
              </ArgonTypography>
              <ArgonTypography variant="caption" color="text" textAlign="center">
                No class sessions found for this parent&apos;s students.
              </ArgonTypography>
            </ArgonBox>
          </Card>
        </ArgonBox>
      ) : (
        <ArgonBox py={3}>
          <ArgonTypography variant="body1" fontWeight="medium" sx={{ px: 3 }} mb={2}>
            Classes List
          </ArgonTypography>
          <ArgonBox
            sx={{
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {Array.isArray(rows) && <Table columns={columns} rows={rows} />}
          </ArgonBox>
        </ArgonBox>
      )}
    </ArgonBox>
  );
}

classManagment.propTypes = {
  parentId: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func,
};

export default classManagment;
